import { useState, useEffect } from 'react';
import LandingNavBar from '../landing-nav-bar/landingNavBar';
import './styles.css'
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CommonInputFloatFull from '../../../components/input/common-input-float-full/commonInputFloatFull';
import CommonFormBorder from '../../../components/common-form-border/commonFormBorder';
import CommonInputRow from '../../../components/input/common-input-row/commonInputRow';
import CommonInputFloatHalf from '../../../components/input/common-input-float-half/commonInputFloafHalf';
import ButtonRow from '../../../components/button/button-row/buttonRow';
import CommonButton from '../../../components/button/common-button/commonButton';
import { displayErrorToast, displaySuccessToast, isEmpty, isValidEmail, screenCaptureAnalytics } from '../../../utils/Utils';
import { useDispatch, useSelector } from 'react-redux'
import { API_CONSTANTS, APP_CONSTANTS } from '../../../utils/AppConstants';
import { contactUsSendMessageRequest, contactUsSendMessageRequestStatus } from '../../../redux/contact-us/contactUs.action'
import { config } from '../../../config';
import PageFooter from '../page-footer/pageFooter';

export default function ContactUsPage() {
    const [isLoading, setLoading] = useState(false)
    const { contactUsSendMessageSuccess, contactUsSendMessageError, contactUsSendMessageReqStatus } = useSelector((state) => state.contactUs)
    const [name, setName] = useState('')
    const [phoneNumber, setPhoneNumber] = useState('')
    const [email, setEmail] = useState('')
    const [message, setMessage] = useState('')
    const dispatch = useDispatch()

    useEffect(() => {
        if (config.environment === APP_CONSTANTS.ENVIRONMENT.PROD) {
            const data = {
                screen: 'CONTACT_US_PAGE',
                screenClass: 'CONTACT_US_PAGE'
            }
            screenCaptureAnalytics(data)
        }
    }, [])

    useEffect(() => {
        if (contactUsSendMessageReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(contactUsSendMessageSuccess.data?.message)
            clearFields()
        } else if (contactUsSendMessageReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(contactUsSendMessageError.message)
        }
        if (contactUsSendMessageReqStatus?.length) {
            dispatch(contactUsSendMessageRequestStatus(''))
        }
    }, [contactUsSendMessageSuccess, contactUsSendMessageError, contactUsSendMessageReqStatus])

    const clearFields = () => {
        setName('')
        setPhoneNumber('')
        setEmail('')
        setMessage('')
    }

    const handleSubmitClick = () => {
        if (isEmpty(name)) {
            displayErrorToast('Name cannot be blank')
        } else if (isEmpty(phoneNumber)) {
            displayErrorToast('Phone number cannot be blank')
        } else if (isEmpty(email)) {
            displayErrorToast('Email id cannot be blank')
        } else if (!isEmpty(email) && !isValidEmail(email)) {
            displayErrorToast('Invalid email id')
        } else if (isEmpty(message)) {
            displayErrorToast('Message cannot be blank')
        } else {
            setLoading(true)
            let emailId = email.toLowerCase()
            const data = {
                name: name,
                number: phoneNumber,
                email: emailId,
                message: message
            }
            dispatch(contactUsSendMessageRequest(data))
        }
    }

    return (
        <>
            <LandingNavBar showHomeLink={true} />
            <div className="cu-container cu-margin-top">
                <h1 className="lp-title text-center">Partners in Workforce Excellence – Let’s Solve It Together</h1>
                <p className="lp-sub-title text-center">Your challenges are our blueprint. Whether optimizing access controls or scaling operations, we collaborate to tailor Togethra to your unique needs. Start with a free trial, then let’s build your ideal system – no templates, just true partnership.</p>
                <p className="lp-sub-title text-center">Have questions? Our team is here to help you get the most out of Togethra.</p>
                <CommonFormBorder>
                    <CommonInputFloatFull
                        type='text'
                        placeholder='Name'
                        id='name'
                        value={name}
                        onChange={e => setName(e.target.value)}
                    />
                    <CommonInputRow>
                        <CommonInputFloatHalf
                            type='text'
                            placeholder='Phone Number'
                            id='number'
                            value={phoneNumber}
                            onChange={e => setPhoneNumber(e.target.value)}
                        />
                        <CommonInputFloatHalf
                            type='text'
                            placeholder='Email Address'
                            id='email'
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                        />
                    </CommonInputRow>
                    <CommonInputFloatFull
                        type='text'
                        id='message'
                        placeholder='Message'
                        value={message}
                        onChange={e => setMessage(e.target.value)}
                        multiline={true}
                        rows={4} />
                    <ButtonRow>
                        <CommonButton label='Submit' onClick={() => { handleSubmitClick() }} />
                    </ButtonRow>
                </CommonFormBorder>

            </div>
            <PageFooter isContactUsPage={true} />
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    );
}